import Router from "next/router";
import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { invalidateRelatedCaches } from "@/modules/loan/store/services/utils/invalidate-related-caches";
import { loanService } from "@/modules/loan/store/services/loan-service";

const deleteLoan = loanService.injectEndpoints({
  endpoints: builder => ({
    deleteLoan: builder.mutation({
      query: ({ loanId, deleteReasonId, deleteReasonComments }) => ({
        url: `loans/${loanId}`,
        method: "DELETE",
        body: { deleteReasonId, deleteReasonComments },
      }),
      invalidatesTags: [
        { type: "Loan", id: "LIST" },
        { type: "Loan", id: "KANBAN" },
        { type: "LoanLendersHeatMap", id: "LIST" },
      ],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(ANALYTIC_EVENTS.LOAN_DELETED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Loan has been deleted!",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );

          invalidateRelatedCaches(dispatch);
          Router.push("/loans");
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteLoanMutation } = deleteLoan;


